import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { ArriveResultService } from '../../../service/arrive-result/arrive-result.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';

@Component({
  selector: 'app-root',
  templateUrl: 'wa1020.component.html',
  styleUrls: ['wa1020.component.css']
})
export class Wa1020Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA1020:入荷実績照会';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  constructor(private router: Router, private arriveResultService: ArriveResultService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.gridOptions = <GridOptions>{
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa1020_${column.getColId()}_idx`);
          columns.push({ idx: parseInt(idx, 10), column: column });
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '入庫ID',
        field: 'instockId',
        sort: 'desc',
        width: this.getColumnWidth('instockId', 100),
        cellClass: 'rightaligned'
      },
      {
        headerName: '入庫ステータス名',
        field: 'stinstockTx',
        width: this.getColumnWidth('stinstockTx', 100)
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100)
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 200)
      },
      {
        headerName: 'ロケーション',
        field: 'locaTx',
        width: this.getColumnWidth('locaTx', 100)
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 100)
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 200)
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 100)
      },
      {
        headerName: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 100)
      },
      {
        headerName: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 50)
      },
      {
        headerName: '入数',
        field: 'amountNr',
        width: this.getColumnWidth('amountNr', 50),
        cellClass: 'rightaligned',
        valueFormatter: insertcomma
      },
      {
        headerName: '入庫数',
        field: 'instockNr',
        width: this.getColumnWidth('instockNr', 50),
        cellClass: 'rightaligned',
        valueFormatter: insertcomma
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 200),
        hide: true
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100),
        hide: true
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 200)
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100),
        hide: true
      }
    ];
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa1020_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa1020_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      localStorage.setItem(`wa1020_${column.colId}_idx`, `${idx}`);
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.headerComponent.isLogin === true) {
        this.onSubmit();
      }
    }, config.waitMsForSearchInNgAfterViewInit);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  changeOwner(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      delete this.rowData;
    }
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onSubmit() {
    this.working = true;

    // ヘッダーのオーナーを変更出来ないようにする。
    this.headerComponent.ownerSelect = true;

    this.arriveResultService
      .get(this.ownerId)
      .then(outputJson => {
        this.working = false;

        // ヘッダーのオーナーを変更できるようにする。
        this.headerComponent.ownerSelect = false;

        console.log(outputJson);
        this.rowData = outputJson.arriveresults;
      })
      .catch(error => {
        this.working = false;

        // ヘッダーのオーナーを変更できるようにする。
        this.headerComponent.ownerSelect = false;

        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa1Arrival/wa1020/wa1020.component.ts